import { Site } from '@snapchat/mw-common';
import { fontTokensWithPlaceholders } from '@snapchat/snap-design-system-marketing';

import { Config } from '../config';

/**
 * Returns font tokens with placeholders for the current site. Sites without Snapchat branding
 * return undefined to skip font fallback injection.
 */
export const getSiteFontFallbacks = (): Record<string, string> | undefined => {
  switch (Config.site) {
    case Site.ARCADIA:
      return;
    case Site.AVALON:
      return;
    case Site.CHEERIOS:
      return;

    default:
      return fontTokensWithPlaceholders;
  }
};
